/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FieldOptionDTO,
} from '../models';

/**
 * 
 */
export class ValuationRuleConfigControllerApi extends runtime.BaseAPI {

    /**
     */
    async getFieldOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FieldOptionDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/private/valuation-rules/config/field-options`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getFieldOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FieldOptionDTO>> {
        const response = await this.getFieldOptionsRaw(initOverrides);
        return await response.value();
    }

}
